/**
 * The reminder before a deadline (docs/modules/tasks.md "Reminders"): the minutes before the deadline the responsible person and the
 * accomplices are told. `null` is the portal's default, `0` is no reminder. The server accepts exactly these values.
 */
export const REMINDER_CHOICES = [0, 15, 60, 240, 1440, 2880] as const;

export type ReminderMinutes = (typeof REMINDER_CHOICES)[number];

/** The value of the select for a task's reminder (`null` → the portal's default). */
export const DEFAULT_REMINDER = 'default';

export const reminderToSelect = (minutes: number | null | undefined): string =>
  minutes === null || minutes === undefined ? DEFAULT_REMINDER : String(minutes);

export const reminderFromSelect = (value: string): number | null => {
  if (value === DEFAULT_REMINDER) return null;
  const minutes = Number(value);
  return (REMINDER_CHOICES as readonly number[]).includes(minutes) ? minutes : null;
};

/** The key under `tasks:reminder.values` that names `minutes` ("1 hour before"). */
export const reminderValueKey = (minutes: number): string =>
  (REMINDER_CHOICES as readonly number[]).includes(minutes) ? String(minutes) : 'other';
